import React from 'react';
import FieldModal from '../../../../components/modals/fieldModal';
import API from '../../../../utils/API';

class DeleteFlowModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            submitting: false,
            success: false,
            error: null
        };
    }

    deleteFlow = () => {
        const { orgId, eventId, flow } = this.props;

        this.setState({ submitting: true });

        API().delete(`Organizations/${orgId}/events/${eventId}/registrationFlows/${flow._id}`)
            .then((res) => {
                if (res.status === 200) {
                    this.setState({
                        submitting: false,
                        success: true
                    });
                    this.props.onDelete(flow._id);
                }
            })
            .catch((err) => {
                this.setState({
                    submitting: false,
                    error: err.response?.data?.message || 'Error deleting flow'
                });
                console.error('Error deleting flow:', err);
            });
    };

    render() {
        const { isOpen, toggle, flow } = this.props;
        const { submitting, success, error } = this.state;

        const flowName = flow?.name || 'this flow';

        return (
            <FieldModal
                size="medium"
                isOpen={isOpen}
                modalTitle="Delete Registration Flow"
                bodyHeaderText="Are you sure you want to delete this flow?"
                isDelete={true}
                overflowHidden={true}
                bodyContent={() => (
                    <div>
                        {error && (
                            <div className="alert alert-danger" role="alert">
                                {error}
                            </div>
                        )}
                        <p>
                            You are about to delete the registration flow: <strong>"{flowName}"</strong><br />
                            This action cannot be undone. Removing this flow will prevent attendees from accessing the associated registration page.
                            The confirmation email associated with this flow will also be deleted.
                        </p>
                    </div>
                )}
                toggle={toggle}
                actionButtonLabel={!success ? !submitting ? 'Delete' : 'Deleting...' : 'Deleted'}
                cancelButtonLabel={success ? 'Close' : 'Cancel'}
                actionButton={() => this.deleteFlow()}
                submitting={submitting}
                actionButtonDisabled={submitting || success}
            />
        );
    }
}

export default DeleteFlowModal;
